import { apiPath } from '@/redux/apiPath';
import { axiosInstance } from '@/services/api/utils/axiosInstance';
import { ThunkConfig } from '@/types/store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getError } from '@/utils/error-report/getError';
import { RemoveCommentPayload } from '../comment.types';

export const removeComment = createAsyncThunk<void, RemoveCommentPayload, ThunkConfig>(
  'comment/removeComment',
  async ({ projectId, commentId, reason }) => {
    try {
      await axiosInstance.delete(apiPath.removeComment(projectId, commentId), {
        data: { reason },
      });
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(getError({ error }));
    }
  },
);
